module.exports = __webpack_public_path__ + "static/type-list-dab245f0310342c53f4979bd9634a191.png";